/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Boolean } from '../../models/boolean';

export interface AuthControllerRegister$Params {
}

export function authControllerRegister(http: HttpClient, rootUrl: string, params?: AuthControllerRegister$Params, context?: HttpContext): Observable<StrictHttpResponse<Boolean>> {
  const rb = new RequestBuilder(rootUrl, authControllerRegister.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Boolean>;
    })
  );
}

authControllerRegister.PATH = '/api/auth/demonstrateur/register';
